
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'EnterpriseInstallationLogo',

  props: {
    installationLogo: {
      type: String as PropType<string>,
      default: ''
    }
  }
})
